// extracted by mini-css-extract-plugin
export default {"dialog-bg":"Hyy6j_dialog-bg"};